import { FC } from 'react'
import { graphql } from 'relay-runtime'
import { useFragment } from 'react-relay/hooks'
import { Breadcrumb_post$key } from './__generated__/Breadcrumb_post.graphql'
import { BreadcrumbForHolderCemetery } from './BreadcrumbForHolderCemetery'
import { BreadcrumbForHolderCity } from './BreadcrumbForHolderCity'
import { BreadcrumbForPost } from './BreadcrumbForPost'
import { BreadcrumbForHolderPrefecture } from '@/components/Breadcrumb/BreadcrumbForHolderPrefecture'
import { EventTracker } from '@lifedot/tracking'

interface BreadcrumbProps {
  post: Breadcrumb_post$key | null
}

export const Breadcrumb: FC<BreadcrumbProps> = ({ post }) => {
  return (
    <EventTracker label="breadCrumb_{innerText}" action="click">
      <BreadcrumbInner post={post} />
    </EventTracker>
  )
}

const BreadcrumbInner: FC<BreadcrumbProps> = ({ post }) => {
  const data = useFragment(fragment, post)
  if (!data) return null

  if (data.holder_cemetery) return <BreadcrumbForHolderCemetery post={data} />
  if (data.holder_city) return <BreadcrumbForHolderCity post={data} />
  if (data.holder_prefecture)
    return <BreadcrumbForHolderPrefecture post={data} />

  return <BreadcrumbForPost post={data} />
}

const fragment = graphql`
  fragment Breadcrumb_post on Post {
    ...BreadcrumbForPost_post
    ...BreadcrumbForHolderCemetery_post
    holder_cemetery {
      name
    }
    ...BreadcrumbForHolderCity_post
    holder_city {
      name
    }
    ...BreadcrumbForHolderPrefecture_post
    holder_prefecture {
      name
    }
  }
`
